var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-image", {
    style: { width: _vm.width + "px", height: _vm.height + "px" },
    attrs: { src: _vm.bindUrl, "preview-src-list": _vm.srcList },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }